module.exports = __webpack_public_path__ + "static/img/3areaA_9.8f366c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/クリスマス/3areaA_9.png
// module id = 839
// module chunks = 1